import classNames from "classnames";
import React from "react";
import Slider from "../slider/Slider";
import Image from "./Image";
import TextImage from "./TextImage";
import "./WidgetCampagne.scss";
export default function WidgetCampagne({ data, campaignType }) {
    const totalItem = data.length;
    const renderArrowControllers = ({ back, next }) => (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: back }, "back"),
        React.createElement("div", { onClick: next }, "next")));
    const renderDotsControllers = (goToSlide) => (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: () => goToSlide(1) }, "o"),
        React.createElement("div", { onClick: () => goToSlide(2) }, "o"),
        React.createElement("div", { onClick: () => goToSlide(3) }, "o")));
    const renderControls = ({ slidesLength, goToSlide, currentPage }) => (React.createElement("ul", { className: "dots-container" }, [...Array(slidesLength).keys()].map((item, i) => (React.createElement("li", { className: "slider-dots", key: i },
        React.createElement("a", { onClick: () => goToSlide(i + 1), className: classNames("slide-dot", {
                "current-dot": i + 1 === currentPage,
            }) }))))));
    const renderElement = (totalItem, item, keyId = 0, small = false) => {
        return item.text == "" ? (React.createElement(Image, { isSmall: small, key: keyId, isPromotion: false, data: item })) : (React.createElement(TextImage, { key: keyId, totalItem: totalItem, isSmall: small, 
            // TODO: Toggle comment
            isPromotion: false, 
            // isPromotion={item.type === "promotion"}
            data: item }));
    };
    return (React.createElement("div", { id: "rt-campaigns" },
        React.createElement("div", { className: "rt-campaigns-row" },
            totalItem < 3 &&
                data.map((campaign, i) => renderElement(totalItem, campaign, i, totalItem === 2 ? true : false)),
            totalItem >= 3 && (React.createElement(React.Fragment, null,
                renderElement(totalItem, data[0], 0, true),
                React.createElement(Slider, { renderControls: renderControls }, data.slice(1).map((campaign, i) => renderElement(totalItem, campaign, i, true))))))));
}
